import React, { useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";
import { Toaster } from "react-hot-toast";

const AppLayout: React.FC = () => {
  const location = useLocation();
  const isVideoPage = location.pathname.startsWith("/projects");

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  return (
    <div className="relative flex flex-col min-h-screen pb-14 sm:pb-0">

      {/* BACKGROUND */}
      {!isVideoPage && (
        <div
          className="fixed inset-0 -z-10 bg-center bg-cover"
          style={{
            backgroundImage: "url('/assets/images/bgillustra/fond.jpeg')",
          }}
        />
      )}

      {isVideoPage && (
        <div className="fixed inset-0 -z-10">
          <video
            ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          >
            <source src="/assets/videos/backroundvideo.mp4" type="video/mp4" />
          </video>

          <div className="absolute inset-0 bg-black/50"></div>
        </div>
      )}

      {/* 🔘 BUTTON OPEN MODAL */}
      {isVideoPage && (
        <button
          onClick={toggleModal}
          className="fixed right-0 text-xs top-24 -translate-y-1/2 z-50
                     bg-white/10 backdrop-blur-md border border-white/20
                     text-white px-2 py-2 rounded-full
                     shadow-lg hover:scale-105 transition"
        >
          Voir la vidéo
        </button>
      )}

      <Header />

      {/* MAIN */}
      <main className="flex-1 overflow-y-auto">
        <div className="py-6 mx-auto max-w-7xl">
          <Outlet />

          <Toaster position="top-right" />
        </div>
      </main>

      <Footer />

      {/* 🎬 MODAL VIDEO */}
      {isModalOpen && isVideoPage && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-md">

          {/* close */}
          <button
            onClick={toggleModal}
            className="absolute top-5 right-5 text-white text-2xl"
          >
            ✕
          </button>

          {/* video modal */}
          <div className="w-[90%] max-w-5xl rounded-xl overflow-hidden shadow-2xl">
            <video
              controls
              autoPlay
              className="w-full h-auto"
            >
              <source
                src="/assets/videos/backroundvideo.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppLayout;